// extracted by mini-css-extract-plugin
export default {"BasketToCardButton":"BasketImg_BasketToCardButton__xGrGV","BasketToCardButtonContainer":"BasketImg_BasketToCardButtonContainer__YHbsv","img":"BasketImg_img__KntY0"};